import axios from "axios";

const API_URL_GET = "https://s5yw47xxgjdwx5hbofivkjz7fe0xslfc.lambda-url.us-east-1.on.aws/review"; // Change if your FastAPI backend runs on a different port
const API_URL_POST = "https://2yczhm5nzy7lbpmc7ot7vaixdu0xmfcq.lambda-url.us-east-1.on.aws/review";

// Fetch all reviews
export const getReviews = async () => {
  try {
    const response = await axios.get(API_URL_GET);
    return response.data;
  } catch (error) {
    console.error("Error fetching reviews:", error);
    return [];
  }
};

// Add a new review
export const addReview = async (reviewData) => {
  try {
    await axios.post(API_URL_POST, reviewData);
    return true;
  } catch (error) {
    console.error("Error posting review:", error);
    return false;
  }
};
